import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './styles.less';
import * as Selectors from '../reducers/selectors';
import PicabooComponentBase from './PicabooComponentBase';

class ZoneOverlayText extends PicabooComponentBase {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { t } = this.props;

    return (
      <>
        <div
          ref={(ref) => {
            this.coverOverlay = ref;
          }}
          className={styles.zoneOverlayText}
          style={{
            width: this.props.width ? this.props.width : '0',
            left: this.props.left ? this.props.left : '0',
          }}
        >
          <div
            className={styles.zoneOverlayTextTop}
            style={{
              height: this.props.isCover ? 12 : this.props.safetyTopHeight,
            }}
          >
            {t(
              'ZONEOVERLAY.Safe area within dotted line. Pink areas may be lost in trimming and binding',
            )}
          </div>

          {this.props.pageWidth / this.props.pageHeight < 2.8 ? (
            <div
              className={styles.zoneOverlayTextSides}
              style={{ display: 'flex', overflow: 'hidden' }}
            >
              {!this.props.hideLeft ? (
                <div
                  className={styles.zoneOverlayTextLeft}
                  style={{
                    width: this.props.isCover ? 12 : this.props.safetyLeftWidth,
                    height: this.props.pageHeight,
                  }}
                >
                  {t(
                    'ZONEOVERLAY.Safe area within dotted line. Pink areas may be lost in trimming and binding',
                  )}
                </div>
              ) : (
                <div />
              )}
              {!this.props.hideRight && (
                <div
                  className={styles.zoneOverlayTextRight}
                  style={{
                    width: this.props.isCover
                      ? 12
                      : this.props.safetyRightWidth,
                    height: this.props.pageHeight,
                  }}
                >
                  {t(
                    'ZONEOVERLAY.Safe area within dotted line. Pink areas may be lost in trimming and binding',
                  )}
                </div>
              )}
            </div>
          ) : (
            <div />
          )}

          <div
            className={styles.zoneOverlayTextBottom}
            style={{
              height: this.props.isCover ? 12 : this.props.safetyBottomHeight,
            }}
          >
            {t(
              'ZONEOVERLAY.Safe area within dotted line. Pink areas may be lost in trimming and binding',
            )}
          </div>
        </div>
      </>
    );
  }
}

ZoneOverlayText.propTypes = {
  hideLeft: PropTypes.bool.isRequired,
  hideRight: PropTypes.bool.isRequired,
  width: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  safetyTopHeight: PropTypes.number.isRequired,
  safetyBottomHeight: PropTypes.number.isRequired,
  safetyLeftWidth: PropTypes.number.isRequired,
  safetyRightWidth: PropTypes.number.isRequired,
  pageWidth: PropTypes.number.isRequired,
  pageHeight: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  wrap: Selectors.wrapSelector(state),
}))(ZoneOverlayText);
